import { render, staticRenderFns } from "./SatecInformation.vue?vue&type=template&id=e39de766&scoped=true"
import script from "./SatecInformation.vue?vue&type=script&lang=ts"
export * from "./SatecInformation.vue?vue&type=script&lang=ts"
import style0 from "./SatecInformation.vue?vue&type=style&index=0&id=e39de766&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e39de766",
  null
  
)

export default component.exports